export const emailValid = (email: string) => {
  return email.match(
    /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
  );
};

/**
 * Returns true if `value` is a number written with digits and an optional
 * decimal comma, e.g. `42` or `199,90` (surrounding whitespace is ignored).
 * Used for incident fields flagged as "Enbart siffror" in admin.
 */
export const isNumericValue = (value: string | null | undefined): boolean => {
  return /^\d+(,\d+)?$/.test((value ?? '').trim());
};

/**
 * Reduces typed input to digits and a single decimal comma. A decimal point is
 * turned into a comma, since some keypads only offer `.` as the separator.
 */
export const sanitizeNumericInput = (value: string): string => {
  const [integerPart, ...decimalParts] = value
    .replace(/\./g, ',')
    .replace(/[^\d,]/g, '')
    .split(',');

  return decimalParts.length > 0 ? `${integerPart},${decimalParts.join('')}` : integerPart;
};

/**
 * Returns true if `phone` is a Swedish mobile number.
 *
 * Accepts domestic (`07X-XXX XX XX`) and international (`+46 7X…`, `0046 7X…`)
 * formats, ignoring spaces, dashes, slashes and parentheses. After the country
 * code and trunk `0` are stripped, a Swedish mobile subscriber number starts
 * with `7` and is 9 digits long.
 */
export const isSwedishMobileNumber = (phone: string | null | undefined): boolean => {
  if (!phone) {
    return false;
  }
  // Reduce to digits only (also drops a leading "+").
  const digits = phone.replace(/\D/g, '');
  // Strip the Swedish country code in its various forms.
  let national = digits;
  if (national.startsWith('0046')) {
    national = national.slice(4);
  } else if (national.startsWith('46')) {
    national = national.slice(2);
  }
  // Strip the national trunk prefix.
  if (national.startsWith('0')) {
    national = national.slice(1);
  }
  // Swedish mobile subscriber numbers start with 7 and are 9 digits long.
  return /^7\d{8}$/.test(national);
};
